import boardingIcon from './boarding-moon.svg';
import walkingIcon from './walking-walker.svg';
import sittingIcon from './sitting-armchair.svg';
import dropInIcon from './drop-in-bone.svg';
import inHomeIcon from './in-home-tennis.svg';
import homeCareIcon from './home-care-home.svg';
import medicalIcon from './medical-health.svg';
import groomingIcon from './grooming-scissors.svg';
import photographyIcon from './photography.svg';
import inHomeTrainingIcon from './in-home-training.svg';
import excursionIcon from './excursion.svg';
import digitalTrainingIcon from './digital-training.svg';
import dropInTennisIcon from './drop-in-tennis.svg';

import { ServiceType } from '../../../../../types/api';

type CustomServiceTypes = 'medical' | 'grooming' | 'excursion' | 'home-care' | 'training' | 'training_digital' | 'daycare' | 'in-home' | 'home_care' | 'misc' | 'digital_training' | 'drop-in';

type ServiceAssetMap = Record<ServiceType | CustomServiceTypes, {
  icon: string;
  title?: string;
}>

export const serviceAssetMap: ServiceAssetMap = {
  walk: {
    icon: walkingIcon,
    title: 'Walking',
  },
  walk_deluxe: {
    icon: walkingIcon,
    title: 'Walking',
  },
  boarding: {
    icon: boardingIcon,
    title: 'Boarding',
  },
  sitting: {
    icon: sittingIcon,
    title: 'Sitting',
  },
  'drop-in': {
    icon: dropInTennisIcon,
    title: 'Drop-In',
  },
  drop_in: {
    icon: dropInTennisIcon,
    title: 'Drop-In',
  },
  drop_in_deluxe: {
    icon: dropInTennisIcon,
    title: 'Drop-In',
  },
  training_digital: {
    icon: digitalTrainingIcon,
    title: 'Digital Training',
  },
  digital_training: {
    icon: digitalTrainingIcon,
    title: 'Digital-Training',
  },
  training: {
    icon: inHomeTrainingIcon,
    title: 'Training',
  },
  daycare: {
    icon: dropInIcon,
    title: 'Daycare',
  },
  medical: {
    icon: medicalIcon,
    title: 'Medical',
  },
  grooming: {
    icon: groomingIcon,
    title: 'Grooming',
  },
  excursion: {
    icon: excursionIcon,
    title: 'Excursion',
  },
  drop_in_30_min: {
    icon: dropInIcon,
    title: 'Drop-In',
  },
  misc: {
    icon: photographyIcon,
    title: 'Misc',
  },
  walk_express: {
    icon: walkingIcon,
    title: 'Walking',
  },
  'home-care': {
    icon: homeCareIcon,
    title: 'Home Care',
  },
  home_care: {
    icon: homeCareIcon,
    title: 'Home Care',
  },
  vet_chat: {
    icon: medicalIcon,
    title: 'Vet Chat',
  },
  meet_and_greet_plus_walk: {
    icon: walkingIcon,
    title: 'Meet & Greet + Walk',
  },
  custom_service: {
    icon: dropInIcon,
    title: 'Custom Service',
  },
  meet_and_greet: {
    icon: dropInIcon,
    title: 'Meet & Greet',
  },
  'in-home': {
    icon: inHomeIcon,
    title: 'In-home',
  },
};
